<form [formGroup]="step2Form" (ngSubmit)="onSubmit()" class="form-container">
  <div class="two-columnas">
    <!-- Selección de zona -->
    <div class="form-group">
      <label for="zona" class="form-label">Zona</label>
      <select id="zona" formControlName="zona" class="form-select">
        <option *ngFor="let zona of zonas" [ngValue]="zona">{{ zona.nombre_zona }}</option>
      </select>
    </div>

    <!-- Selección de campo -->
    <div class="form-group">
      <label for="campo" class="form-label">Campo</label>
      <select id="campo" formControlName="campo" [disabled]="campos.length === 0" class="form-select">
        <option *ngFor="let campo of campos" [value]="campo.id_campo">{{ campo.nombre_campo }}</option>
      </select>
    </div>


    <!-- Fecha de reserva -->
    <div class="form-group">
      <label for="fechaReserva" class="form-label">Fecha</label>
      <input type="date" id="fechaReserva" formControlName="fechaReserva" class="form-input" />
    </div>

    <!-- Feriado (Checkbox estilizado) -->
    <div class="checkbox-container">
      <input type="checkbox" id="feriado" formControlName="feriado" class="custom-checkbox" />
      <label for="feriado" class="custom-label">Feriado</label>
    </div>


  </div>

  <!-- Botón para continuar -->
  <div class="form-group form-button-container">
    <button type="submit" class="form-button">Continuar</button>
  </div>
</form>
